import React from 'react';
import {Link} from 'react-router-dom';
import {Image,Badge,Button} from 'react-bootstrap';
import PropTypes from 'prop-types';
import Icofont from 'react-icofont';


class MenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: this.props.item.quantity || 0,
      show: this.props.show || true,
      max:this.props.maxValue || 50,
      min:this.props.minValue || 0,
     
    };
  }
  
  IncrementItem = () => {
    this.props.incrementItem(this.props.item);

  }
  DecreaseItem = () => {
    this.props.decreaseItem(this.props.item);
  }

  render() {
      return (
          <>
        
        <div className="list-card bg-white h-100 rounded overflow-hidden position-relative shadow-sm">
               <div className="list-card-image">
                   {/*this.props.rating ? (
                    <div className="star position-absolute">
                      <Badge variant="success">
                        <Icofont icon='star'/> {this.props.rating}
                      </Badge>
                    </div>
                    )
                    :""
                   */}
                 <div className={`favourite-heart position-absolute ${this.props.favIcoIconColor}`}>
                    <Link to="#">
                    <Icofont icon="ui-press" className="text-danger food-item" />
                    </Link>
                  </div>
                  {this.props.showPromoted ? (
                    <div className="member-plan position-absolute">
                      <Badge variant={this.props.promotedVariant}>Promoted</Badge>
                    </div>
                    )
                      :""
                  }
                  <Link to="#" onClick={this.props.onViewClick}>
                    <Image src={this.props.image} className={this.props.imageClass} alt={this.props.imageAlt} />
                  </Link>
               </div>
               <div className="p-3 position-relative">
                  <div className="list-card-body">
                     <h6 className="mb-1"><Link to="#" className="text-black" onClick={this.props.onViewClick}>{this.props.title}</Link></h6>
                     {<p class="text-gray mb-3">{this.props.subTitle}</p>
                   }
                   {(this.props.price)? (
                       <p className="text-gray time mb-0">
                         <Link className="btn btn-link btn-sm pl-0 text-black pr-0" to="#">
                           {this.props.priceUnit}{this.props.price} </Link>
                           {(this.props.isNew)? (<Badge variant="success" className='ml-1'>NEW</Badge>):"" }

                         {this.props.item.quantity===0?
                            <span className="float-right">
                              <Button variant='outline-secondary' onClick={this.IncrementItem} size="sm">ADD</Button>
                            </span>
                            :
                            <span className="count-number float-right">
                               <Button variant="outline-secondary" onClick={this.DecreaseItem} className="btn-sm left dec"> <Icofont icon="minus" /> </Button>
                               <input className="count-number-input" type="text" value={this.props.item.quantity} readOnly/>
                               <Button variant="outline-secondary" onClick={this.IncrementItem} className="btn-sm right inc"> <Icofont icon="icofont-plus" /> </Button>
                            </span>
                         }
                       </p>
                       ):''
                   }
                  </div>
               </div>
            </div>
            </>
    );
  }
}


MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  image: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  isNew: PropTypes.bool,
  subTitle: PropTypes.string,
  price: PropTypes.number.isRequired,
  priceUnit: PropTypes.string.isRequired,
  showPromoted: PropTypes.bool,
  promotedVariant: PropTypes.string,
  favIcoIconColor: PropTypes.string,
  rating: PropTypes.string,
  id: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  getValue: PropTypes.func.isRequired,
  onViewClick: PropTypes.func.isRequired,
};
MenuItem.defaultProps = {
  imageAlt:'',
  imageClass:'',
  isNew: false,
  subTitle: '',
  price: '',
  priceUnit:'$',
  showPromoted: false,
  promotedVariant: 'dark',
  favIcoIconColor: '',
  rating: ''
}

export default MenuItem;